import {FOLDER_CONTENT_PAGE_LIMIT} from '../constants/docsApi';

export const createGetFolderContentsMethod = (documentsCache, fetchFolderContents) => urn =>
  new Promise((resolve, reject) => {
    const offset = documentsCache[urn] && documentsCache[urn].nextOffset ? documentsCache[urn].nextOffset : 0;
    const options = {
      limit: FOLDER_CONTENT_PAGE_LIMIT,
      offset
    };
    fetchFolderContents(urn, options, resolve, reject);
  }).then(folderContents => {
    if (!documentsCache[urn]) {
      documentsCache[urn] = {};
      documentsCache[urn].nextOffset = 0;
      documentsCache[urn].folderUrns = [];
      documentsCache[urn].documentUrns = [];
    }

    documentsCache[urn].hasNextPage = folderContents.hasNextPage;
    documentsCache[urn].nextOffset += FOLDER_CONTENT_PAGE_LIMIT;

    //TODO - Here we fix issue with Docs API that returns the same folder in two different requests. Check https://jira.autodesk.com/browse/ALEX-21498 for more info
    const folders = folderContents.folders.filter(f => !documentsCache[urn].folderUrns.includes(f.urn));
    const documents = folderContents.documents.filter(d => !documentsCache[urn].documentUrns.includes(d.urn));
    documentsCache[urn].folderUrns = documentsCache[urn].folderUrns.concat(folderContents.folders.map(f => f.urn));
    documentsCache[urn].documentUrns = documentsCache[urn].documentUrns.concat(
      folderContents.documents.map(f => f.urn)
    );

    return {...folderContents, folders, documents};
  });

export const createHasMoreFolderContents = documentsCache => ({folder}) => {
  const data = documentsCache[folder.urn];
  return data?.hasNextPage ?? false;
};
